const INIT = 'api-config/INIT';
const init = (payload)=>({
        type: INIT,
        payload
    })
;

export { INIT, init };
//# sourceMappingURL=actions.js.map
